<template>
  <t-form labelWidth="100px">
    <!-- v-if="cptDataForm.dataSource == '4'" -->
        <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="字体颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.textColor" size="small"/>
    </t-form-item>
    <t-form-item label="字体大小">
      <t-input-number :min="10" :max="250" v-model="attribute.fontSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="滚动速度">
      <t-input-number :min="1" :max="150" v-model="attribute.step" size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="滚动方式">
      <t-radio-group v-model="attribute.scrollType" size="small">
        <t-radio :value="1">横向</t-radio>
        <t-radio :value="2">竖向</t-radio>
      </t-radio-group>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-scroll-text-option",
  components: {CptData},
  props: {
    attribute: Object,
    cptDataForm:Object,
    currentCpt:Object,
  },
}
</script>

<style scoped>

</style>
